import { Navigate, useLocation, useOutlet } from "react-router";
import { useAuthContext } from "app/presentation/contexts/auth/context";
import { GHOST_ENTRY_PATH, REDIRECT_URL_KEY } from "app/presentation/constants/app.constant";
import { SplashScreen } from "app/presentation/components/template/SplashScreen";

export default function AuthGuard() {
  const outlet = useOutlet();
  const { isAuthenticated, isInitialized, isLoading, user } = useAuthContext();
  const location = useLocation();

  // Afficher le splash screen pendant l'initialisation
  if (!isInitialized || isLoading) {
    return <SplashScreen />;
  }

  if (!isAuthenticated) {
    const fullPath = `${location.pathname}${location.search || ""}${location.hash || ""}`;
    const encoded = encodeURIComponent(fullPath || "/");

    return (
      <Navigate
        to={`${GHOST_ENTRY_PATH}?${REDIRECT_URL_KEY}=${encoded}`}
        replace
      />
    );
  }

  // Force le changement de mot de passe si nécessaire
  if (user?.mustChangePassword && location.pathname !== "/settings/sessions") {
    return <Navigate to="/settings/sessions" replace />;
  }

  // Isolation supplémentaire par rôle pour éviter les fuites entre vues
  const appMode = import.meta.env.VITE_APP_MODE || import.meta.env.MODE;
  const userRole = (user?.role || "").toLowerCase();

  const isAdminApp = appMode === "admin" || appMode === "entreprise" || appMode === "admin-limited";
  const isDriverApp = appMode === "driver";

  // Vérifier si c'est un profil admin
  const isAdminProfile = ["admin", "superadmin", "super_admin", "entreprise", "controleur", "gestionnaire", "accountant", "support"].includes(userRole);
  // Vérifier si c'est un profil chauffeur (chauffeur ou driver)
  const isDriverProfile = ["chauffeur", "driver"].includes(userRole);

  // Si on est sur une app admin mais qu'on n'est pas un profil autorisé
  if (isAdminApp && !isAdminProfile) {
    return <Navigate to="/login?error=unauthorized_admin" replace />;
  }

  // Si on est sur l'app chauffeur mais qu'on n'est pas un chauffeur
  if (isDriverApp && !isDriverProfile) {
    return <Navigate to="/login?error=unauthorized_driver" replace />;
  }

  return <>{outlet}</>;
}